import { Button, Col, Dropdown, Menu, Row, message } from "antd";
import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import Initial from "../../../../../assets/images/initial.png";
import AddendumSign from "../../../../../assets/images/AddendumSign.png";

import "./NewLeaseTemplate.css";

const NewAddendum = () => {
  const [content, setContent] = useState("test");
  const [isEmpty, setIsEmpty] = useState(false);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const [pages, setPages] = useState([
    {
      id: 1,
      pageTitle: "",
      sections: [{ id: "1.1", sectionTitle: "", sectionBody: "" }],
    },
  ]);

  const [isFocused, setIsFocused] = useState({
    1.1: false, // initial state for section with ID "1.1"
    // add more keys for other section IDs as needed
  });

  function handlePageTitleChange(e) {
    const newPages = [...pages];
    newPages[0].pageTitle = e.target.innerHTML;
    setPages(newPages);

    const newContent = e.target.innerHTML;

    setIsEmpty(newContent.trim() === "");
  }

  function handleSectionTitleChange(e, sectionIndex) {
    const newPages = [...pages];
    newPages[0].sections[sectionIndex].sectionTitle =
      e.target.innerHTML;
    setPages(newPages);

    const newContent = e.target.innerHTML;

    setIsEmpty(newContent.trim() === "");
  }

  function addSection() {
    const newSection = {
      id: `${0 + 1}.${
        pages[0].sections.length + 1
      }`,
      sectionTitle: "",
      sectionBody: "",
    };
    const newPages = [...pages];
    newPages[0].sections.push(newSection);
    setPages(newPages);
  }

  const handleBlur = (event) => {
    setIsFocused(false);

    const newContent = event.target.innerHTML;

    console.log(newContent);
    setContent(newContent);
    setIsEmpty(newContent.trim() === "");
  };
  const handleChange = (event) => {
    const value = event.target.innerHTML;
    setIsEmpty(false);
    if (value.trim().length > 0) {
      event.target.removeAttribute("data-placeholder");
    } else {
      event.target.setAttribute("data-placeholder", "Enter page title here");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleEditor = (newEditorState) => {
    setEditorState(newEditorState);

    setIsEmpty(false);
  };
  const handleFocus = (sectionId) => {
    setIsFocused((prevIsFocused) => ({
      ...prevIsFocused,
      [sectionId]: true,
    }));
  };

  const handleEditorBlur = (sectionIndex, sectionId) => {
    const contentState = editorState.getCurrentContent();
    const contentRaw = convertToRaw(contentState);
    const content = JSON.stringify(contentRaw);
    const parsedContent = JSON.parse(content);
    const blocks = parsedContent.blocks;

    let text = "";
    for (let i = 0; i < blocks.length; i++) {
      text += blocks[i].text;
    }

    const newContent = text;

    setIsEmpty(newContent.trim() === "");
    const newPages = [...pages];
    newPages[0].sections[sectionIndex].sectionBody = text;
    setPages(newPages);
    setIsFocused(false);

    setIsFocused((prevIsFocused) => ({
      ...prevIsFocused,
      [sectionId]: false,
    }));
  };


  function handleImageClick(pageId, sectionId) {
    // Find the page with the matching id
    const pageIndex = pages.findIndex((page) => page.id === pageId);

    // If a page with the matching id is found, find the section with the matching id within the page
    if (pageIndex >= 0) {
      const sectionIndex = pages[pageIndex].sections.findIndex(
        (section) => section.id === sectionId
      );

      // If a section with the matching id is found, update the state with the new image
      if (sectionIndex >= 0) {
        const updatedSection = {
          ...pages[pageIndex].sections[sectionIndex],
          initials: Initial, // Replace myImage with your image
        };

        const updatedSections = [
          ...pages[pageIndex].sections.slice(0, sectionIndex),
          updatedSection,
          ...pages[pageIndex].sections.slice(sectionIndex + 1),
        ];

        setPages([
          ...pages.slice(0, pageIndex),
          {
            ...pages[pageIndex],
            sections: updatedSections,
          },
          ...pages.slice(pageIndex + 1),
        ]);
      }
    }
  }

  function CustomMessageContent({ heading, message }) {
    return (
      <div>
        <h3>{heading}</h3>
        <p>{message}</p>
      </div>
    );
  }

  function deleteSection(pageId, sectionId) {
    const updatedPages = [...pages];
    const page = updatedPages.find((p) => p.id === pageId);
    if (page.sections.length === 1) {
      message.error(
        <CustomMessageContent
          heading="This section cannot be deleted!"
          message="A lease page should have at least one section."
        />,
        5
      );
    } else {
      if (page) {
        const updatedSections = page.sections.filter((s) => s.id !== sectionId);
        page.sections = updatedSections;
        setPages(updatedPages);
      }
    }
  }


  return (
    <div className="NewLeaseTemplate">
      <div className="content">
        <div className="header">
          <Row gutter={16} justify="center">
            <Col span={10}>
              <Row justify="space-between" gutter={16} align="middle">
                <Col span={16}>
                  <p>
                    <i className="fa-solid fa-pencil"></i> <em>Editing: </em>
                    <span className="badge"> Unsaved</span>
                  </p>
                  <div
                    contentEditable={true}
                    onBlur={handleBlur}
                    onInput={handleChange}
                    onKeyPress={handleKeyPress}
                    dangerouslySetInnerHTML={{ __html: content }}
                    style={{ whiteSpace: "nowrap" }}
                    className={
                      content === "" && isEmpty
                        ? "editableTemplateTitle is-invalid"
                        : "editableTemplateTitle"
                    }
                  />
                  {content === "" && isEmpty && (
                    <span style={{ color: "red" }}>This field is required</span>
                  )}
                </Col>
                <Col span={6}>
                  <Row align="bottom" justify="space-between">
                    <Col span={10}>
                      <Button type="primary">Save</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <Row
          gutter={16}
          justify="center"
          style={{ paddingTop: "11em", marginLeft: "0", marginRight: "0" }}
        >
          <Col span={10}>
            <div className="leasingLetterHead">
              <h1>Integrity Oklahoma LLC</h1>
              <p style={{ fontWeight: "300px" }}>
                PO Box 1451 • Bethany, OK 73008 <br />
                (405) 283-6521
              </p>
            </div>

            <div style={{ paddingTop: "50px" }}>
              <Row justify="start" gutter={16}>
                <Col span={2}>
                  <h1 className="leasePageNumber">
                    1
                  </h1>
                </Col>

                <Col span={14}>
                  <div
                    contentEditable={true}
                    onBlur={handlePageTitleChange}
                    onInput={handleChange}
                    onKeyPress={handleKeyPress}
                    dangerouslySetInnerHTML={{
                      __html: pages[0]?.pageTitle,
                    }}
                    style={{ whiteSpace: "nowrap" }}
                    className={
                      pages[0]?.pageTitle === "" && isEmpty
                        ? "editableTemplateTitle pageTitle is-invalid"
                        : "editableTemplateTitle pageTitle"
                    }
                    data-placeholder={ "Click to add a page title"}
                  />

                  {pages[0]?.pageTitle === "" && isEmpty && (
                    <span style={{ color: "red" }}>This field is required</span>
                  )}
                  {pages[0]?.sections.map((section, index) => (
                    <div key={section.id}>
                      <Row gutter={16} align="middle" justify="space-between">
                        <Col span={1}>
                          <p className="numberOfSubSection">
                            {pages[0]?.id}.{index+1}
                          </p>
                        </Col>
                        <Col span={16}>
                          <div
                            contentEditable={true}
                            onBlur={(e) => handleSectionTitleChange(e, index)}
                            onInput={handleChange}
                            onKeyPress={handleKeyPress}
                            dangerouslySetInnerHTML={{
                              __html: section.sectionTitle,
                            }}
                            style={{ whiteSpace: "nowrap" }}
                            className={
                              section.sectionTitle === "" && isEmpty
                                ? "editableTemplateTitle is-invalid"
                                : "editableTemplateTitle"
                            }
                            data-placeholder="Click to add a section title"
                          />
                          {section.sectionTitle === "" && isEmpty && (
                            <span style={{ color: "red" }}>
                              This field is required
                            </span>
                          )}
                        </Col>
                        <Col span={5}>
                          <Dropdown
                            trigger={["click"]}
                            key={section.id}
                            overlay={
                              <Menu>
                                <Menu.Item key="1" onClick={addSection}>
                                  <i className="fa-solid fa-plus"></i> Add
                                  Section Above
                                </Menu.Item>
                                <Menu.Item
                                  key="2"
                                  onClick={() =>
                                    handleImageClick(
                                      pages[0]?.id,
                                      section.id
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-pencil"></i> Add
                                  Initials
                                </Menu.Item>
                                <Menu.Item
                                  key="3"
                                  onClick={() =>
                                    deleteSection(
                                      pages[0]?.id,
                                      section.id
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-trash"></i> Delete
                                  Section
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <Button type="text">
                              Options <i className="fa-solid fa-ellipsis"></i>
                            </Button>
                          </Dropdown>
                        </Col>
                      </Row>
                      {isFocused[section.id] ? (
                        <Editor
                          editorState={editorState}
                          onEditorStateChange={handleEditor}
                          onBlur={() => handleEditorBlur(index, section.id)}
                        />
                      ) : (
                        <>
                          <div
                            contentEditable={true}
                            onBlur={() => handleBlur(section.id)}
                            onFocus={() => handleFocus(section.id)}
                            dangerouslySetInnerHTML={{
                              __html: section.sectionBody,
                            }}
                            style={{ whiteSpace: "nowrap" }}
                            className={
                              section.sectionBody === "" && isEmpty
                                ? "editableTemplateTitle sectionBody is-invalid"
                                : "editableTemplateTitle sectionBody"
                            }
                            data-placeholder={
                              section.sectionBody === ""
                                ? "Click to add section content"
                                : ""
                            }
                          />
                          {section.sectionBody === "" && isEmpty && (
                            <span style={{ color: "red" }}>
                              This field is required
                            </span>
                          )}
                        </>
                      )}
                      {section.initials ? (
                        <Row justify="end">
                          <Col>
                            <img
                              src={Initial}
                              alt="Initial here"
                              style={{ height: "100%", width: "100%" }}
                            />
                          </Col>
                        </Row>
                      ) : null}
                    </div>
                  ))}
                  <button onClick={addSection} className="addSectionBtn">
                    <i className="fa-solid fa-plus"></i> Add Section
                  </button>
                  <Row justify="end">
                    <Col>
                      <img
                        src={AddendumSign}
                        alt="Initial here"
                        style={{ height: "100%", width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>

      <div className="footer">
        <Row justify="space-between">
          <Col span={8}>
            <p>
              <i className="fa-solid fa-house"></i> | © 2023 SayEagle.
            </p>
          </Col>
          <Col span={4}>
            <h2 style={{ fontSize: "26px" }}>SayEagle</h2>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NewAddendum;
